import { Notify } from 'notiflix/build/notiflix-notify-aio';

import { setGlossaryList, setArticle } from '@/redux/glossary/glossarySlice';

import glossaryService from '@/services/glossaryService';

const getGlossary = (limit, offset) => async dispatch => {
  try {
    const response = await glossaryService.getGlossary(limit, offset);
    const {
      data: { items },
    } = response;

    dispatch(setGlossaryList(items));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetGlossary failure');
  }
};

const searchGlossary = (language, word) => async dispatch => {
  try {
    const response = await glossaryService.searchGlossary(language, word);
    const { data } = response;

    dispatch(setGlossaryList(data));
  } catch (e) {
    Notify.failure(
      e.response?.data?.message || 'Request SearchGlossary failure',
    );
  }
};

const getArticle = id => async dispatch => {
  try {
    const response = await glossaryService.getArticle(id);
    const { data } = response;

    dispatch(setArticle(data));
  } catch (e) {
    Notify.failure(e.response?.data?.message || 'Request GetArticle failure');
  }
};

export default {
  getGlossary,
  searchGlossary,
  getArticle,
};
